module.exports = __webpack_public_path__ + "static/media/falkenbergvapen.b05a0e6f.png";